import type { StepWithArrowOffset } from 'shared/ui/joyride-tour/types'

export const createCreateObjectEntryHintSteps = (
  content: string,
): StepWithArrowOffset[] => [
  {
    target: '#create-object-entry-button',
    content,
    placement: 'top',
    disableBeacon: true,
    disableScrolling: true,
    spotlightPadding: 0,
  },
]
